import React from "react";
import { ChevronDoubleLeftIcon, ChevronDoubleRightIcon } from "@heroicons/react/24/outline";
import { useNavigate, useParams } from "react-router-dom";
import Logo from "../../../fronteraLogo.png";

const HeaderSection = ({ collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const currentUsername = localStorage.getItem("username");

  return (
    <div className="relative flex items-center h-[60px] px-2 gap-2 max-w-full overflow-hidden justify-between w-full">
      {/* 🔻 Sidebar Toggle Button */}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="text-[#0077B5] hover:text-[#005a8d] transition bg-white rounded-full p-1 shadow-sm"
          aria-label="Toggle sidebar"
        >
          {collapsed ? (
            <ChevronDoubleRightIcon className="w-6 h-6 text-black" />
          ) : (
            <ChevronDoubleLeftIcon className="w-6 h-6 text-black" />
          )}
        </button>
      {/* Brand Section */}
      <div className="flex items-center gap-2">
        
        {/* Logo + Label */}
        <div
          className="flex items-center cursor-pointer max-w-[160px] sm:max-w-full"
          onClick={() => navigate(`/${currentUsername}/explore`)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter") navigate(`/${currentUsername}/explore`);
          }}
        >
          <img src={Logo} alt="Frontera Logo" className="w-20 object-contain" />
          <div className="text-[20px] font-bold leading-none tracking-tight text-[#0D062D] font-inter ml-[-12px] hidden sm:inline">
            Frontera
          </div>
        </div>

      </div>
    </div>
  );
};

export default HeaderSection;
